// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1vfqo","choiceBoxes":"toolbarselects_choiceBoxes___kNop","simpleField":"toolbarselects_simpleField__1L9hC"};